import React, { useState } from 'react';
import { storage } from '../../firebase';
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes, } from "firebase/storage";

import Navbar from '../inc/Navbar';
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import "./Contact.css";




import { v4 as uuidv4 } from "uuid";
import Contactform from './Contactfrom';

// import ExportContact from './ExportContact';


function Contact() {

  const [pdfFile, setPdfFile] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState("");

  const [pdfUpload, setPdfUpload] = useState(null);
  const [PdfList, setPdfList] = useState([]);



  const handleUpload = async () => {
    if (!pdfFile) return alert("Please select a PDF file.");

    const fileRef = ref(storage, `pdfs/${pdfFile.name}_${uuidv4()}`);
    try {
      const snapshot = await uploadBytes(fileRef, pdfFile);
      const url = await getDownloadURL(snapshot.ref);
      setDownloadUrl(url);
      alert("PDF uploaded successfully!");
    } catch (err) {
      console.error("Upload error:", err);
      alert("Failed to upload PDF.");
    }
  };





  return (

    <>
      <Navbar />
      <br />


      <br />
      <br />
      <br>
      </br>
      <div className='packermovershoogle'>
        <div className="album py-1">

          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <ScrollToTop smooth top="100" color="Gray" />
      <div className="p-4 mb-2 bg-light text-dark">




        <div className="album py-0">

          <div className="container">

            <div className="row justify-content-center">

              <div className="col-md-5 mt-3" >


                <h6 className="card-text">AT INDIA PACKERS</h6>


                <h6 style={{ color: "#0F056B" }}> Register Office Address</h6>
                <hr />

                <ul className="list-unstyled">

                  <h6 style={{ color: "#0F056B" }} className="card-text "> <b>AT INDIA PACKERS MOVERS</b></h6>

                  <p style={{ color: "#0F056B" }} className="card-text mb-1">Vill-Kulgachi, Po+PS-Haroa, Haroa Bus Stop  <br></br>North 24 Parganas, WB-743425</p>



                  <h6 className='mt-3' style={{ color: "#0F056B" }}> Corporate Office </h6>
                  <hr className='mb-0' />

                  <ul class="list-unstyled">

                    <p style={{ color: "#0F056B" }} className="card-text mb-1">Jatragachi Road & Flyover, AA II, Deshbandhu Nagar, Newtown, 
                      Action area -II</p>
                    <p style={{ color: "#0F056B" }} className="card-text mb-1">Kolkata, West Bengal 700161</p>


                  </ul>
                </ul>

                <p className="card-text"> <br />Copyright © AT INDIA PACKERS</p>



                <div className="d-flex justify-content-between align-items-center">


                </div>

              </div>
              <div className="col-md-4 mt-3" >

                <h6 style={{ color: "Gray" }} className="card-text">Contact Details</h6>

                <a href="tel: +91 8101278298">
                  <p style={{ color: "#0F056B" }} className="mb-2" >    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                  </svg> +91 81012 78298
                  </p> </a>


                <a href="tel: +91 9903144864">
                  <p style={{ color: "#0F056B" }} className="mb-2" >    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                  </svg> +91 99031 44864
                  </p> </a>
                <a href="tel: +91 7551001003">
                  <p style={{ color: "#0F056B" }} className="mb-2" >    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                  </svg> +91 755-100-100-3
                  </p> </a>


                <br />


                <div className="d-flex justify-content-between align-items-center">

                </div>

              </div>
              <div className="col-md-3 mt-3" >
                <h6 style={{ color: "Gray" }} className="card-text " > <b>For any enquiry contact us at</b></h6>


                <a href='mailto: atindiapackers@gmail.com'>atindiapackers@gmail.com</a>


                <div className="d-flex justify-content-between align-items-center">

                </div>

              </div>
            </div>
          </div>
        </div>
        <br />

        {/* <ExportContact month={6} year={2025} /> 


      <ExportFranchise month={6} year={2025} />  */}







        <div className="album py-0">

          <div className="container">
            <div className='card'>
              <div class="card-body">
                <center>
                  <h4 style={{ color: "#054998ff" }}>Contact <b>AT INDIA PACKERS </b></h4>
                </center>
                <Contactform />
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>



    </>

  );
}

export default Contact;